import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/products/product1.jpg'
import _imports_1 from '@/assets/images/products/product2.jpg'
import _imports_2 from '@/assets/images/products/product3.jpg'
import _imports_3 from '@/assets/images/products/product4.jpg'
import _imports_4 from '@/assets/images/products/product5.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_4 = { class: "trezo-card-content" }
const _hoisted_5 = { class: "table-responsive overflow-x-auto" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "text-black dark:text-white" }
const _hoisted_8 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_9 = { class: "flex items-center gap-[9px]" }
const _hoisted_10 = {
  href: "javascript:void(0);",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_11 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_12 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_13 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_14 = { class: "flex items-center gap-[9px]" }
const _hoisted_15 = {
  href: "javascript:void(0);",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_16 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_17 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_18 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_19 = { class: "flex items-center gap-[9px]" }
const _hoisted_20 = {
  href: "javascript:void(0);",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_21 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_22 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_23 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_24 = { class: "flex items-center gap-[9px]" }
const _hoisted_25 = {
  href: "javascript:void(0);",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_26 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_27 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_29 = { class: "flex items-center gap-[9px]" }
const _hoisted_30 = {
  href: "javascript:void(0);",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_31 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_32 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"trezo-card-title\"><form class=\"relative sm:w-[265px]\"><label class=\"leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2\"><i class=\"material-symbols-outlined !text-[20px]\"> search </i></label><input type=\"text\" placeholder=\"Search category here.....\" class=\"bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400\"></form></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add "),
            _createTextVNode(" Add New Category ")
          ], -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[53] || (_cache[53] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ]),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Image "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Name "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Total Products "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Slug "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Description "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Status "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Action ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_7, [
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("img", {
                  width: "50",
                  alt: "product-image",
                  src: _imports_0,
                  class: "rounded-full"
                })
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " Watch ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 54 ")
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " watch ")
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " What is lorem ipsum? ")
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, _cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("img", {
                  width: "50",
                  alt: "product-image",
                  src: _imports_1,
                  class: "rounded-full"
                })
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " Headphone ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 13 ")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " headphone ")
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Why do we use it? ")
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, _cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_17, _cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[26] || (_cache[26] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("img", {
                  width: "50",
                  alt: "product-image",
                  src: _imports_2,
                  class: "rounded-full"
                })
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " Mobile ", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 42 ")
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " mobile ")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Where does it come from? ")
              ], -1)),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Deactive ")
              ], -1)),
              _createElementVNode("td", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_21, _cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_22, _cache[25] || (_cache[25] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _cache[37] || (_cache[37] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("img", {
                  width: "50",
                  alt: "product-image",
                  src: _imports_3,
                  class: "rounded-full"
                })
              ], -1)),
              _cache[38] || (_cache[38] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " Speaker ", -1)),
              _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 32 ")
              ], -1)),
              _cache[40] || (_cache[40] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " speaker ")
              ], -1)),
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Where can I get some? ")
              ], -1)),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, _cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_26, _cache[34] || (_cache[34] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_27, _cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[46] || (_cache[46] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer"
                  })
                ])
              ], -1)),
              _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("img", {
                  width: "50",
                  alt: "product-image",
                  src: _imports_4,
                  class: "rounded-full"
                })
              ], -1)),
              _cache[48] || (_cache[48] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " Electronics ", -1)),
              _cache[49] || (_cache[49] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 100 ")
              ], -1)),
              _cache[50] || (_cache[50] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " electronics ")
              ], -1)),
              _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Contrary to popular belief ")
              ], -1)),
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Active ")
              ], -1)),
              _createElementVNode("td", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_30, _cache[43] || (_cache[43] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_31, _cache[44] || (_cache[44] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, _cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "5",
        total: "36",
        class: "px-[20px] py-[12px] md:py-[14px] rounded-b-md border-l border-r border-b border-gray-100 dark:border-[#172036]"
      })
    ])
  ]))
}